export default "__VITE_ASSET__BpNX7oRI__"